import { watch, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

export function useTitle() {
  const { t, locale } = useI18n();
  const route = useRoute();

  const updateTitle = () => {
    let pageTitle = 'QuickPrice';
    
    if (route.meta.titleKey) {
      const localizedTitle = t(`page_titles.${route.meta.titleKey}`);
      pageTitle = localizedTitle || `${route.meta.titleKey} - QuickPrice`;
    } else if (route.meta.title) {
      // Fallback для старого формата
      pageTitle = route.meta.title;
    }
    
    document.title = pageTitle;
    
    // Обновляем мета-описание
    if (route.meta.titleKey) {
      const localizedDescription = t(`meta_descriptions.${route.meta.titleKey}`);
      if (localizedDescription && localizedDescription !== `meta_descriptions.${route.meta.titleKey}`) {
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
          metaDescription.setAttribute('content', localizedDescription);
        }
      }
    }
    
    // Обновляем атрибут lang в HTML
    const htmlElement = document.documentElement;
    if (htmlElement) {
      htmlElement.setAttribute('lang', locale.value);
    }
    
    return pageTitle;
  };

  // Обновляем title при смене языка
  watch(locale, () => {
    updateTitle();
  });

  // Инициализируем title при монтировании
  onMounted(() => {
    updateTitle();
  });

  return {
    updateTitle
  };
} 